const remove = function (array, value) {
  let index = array.indexOf(value)
  if (index > -1) {
    array.splice(index, 1)
  }
  return index
}

// 移除对象数组，匹配唯一key
const removeByKey = function (array, key, val) {
  let index = array.findIndex(value => value[key] === val)
  if (index > -1) {
    array.splice(index, 1)
  }
  return index
}

// 对象数组转map
const arrayToMap = function (array, key) {
  let map = new Map()
  array.forEach(v => map.set(v[key], v))
  return map
}

export default {remove, removeByKey, arrayToMap}
